import { IconButton, InputAdornment, Stack, Typography } from '@mui/material';
import { InputText } from '@farmshare/ui-components';
import { useState } from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export function SetPasswordForm() {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (
    <Stack spacing={3}>
      <Typography variant="body2" color="text.secondary">
        Set a password to sign in with your email or phone number instead of
        receiving a one-time code each time you log in.
      </Typography>

      <InputText
        label="New Password"
        nameOverride="newPassword"
        type={showPassword ? 'text' : 'password'}
        required
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowPassword(!showPassword)}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
        hint="Must be at least 6 characters"
      />

      <InputText
        label="Confirm Password"
        nameOverride="confirmPassword"
        type={showConfirmPassword ? 'text' : 'password'}
        required
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                edge="end"
              >
                {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Stack>
  );
}
